import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { map, catchError } from 'rxjs/operators';
import { ConsultaPaginada, ParamConsulta } from '@generals';

@Injectable()
export class WebHookService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  retornaStatusPagamento(transactionId: number) {
    return this.http
      .get(this.UrlService + `webHook/Pooling/${transactionId}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));;
  }

getSnifferData(snifferId: number, consulta: ParamConsulta) {
  return this.http
    .post(this.UrlService + `webhook/sniffer/${snifferId}`, consulta)
    .pipe(
      map((res: any) => res.data as ConsultaPaginada),
      catchError(super.serviceError)
    );
}

}